module.exports = __webpack_public_path__ + "static/room-373a0f19fe790d38dfc5baba0f331a08.jpg";